<template>
  <div id="bg">
    <Transition name="slide-up">
      <div v-if="enabled" id="color">
        <div id="text-wrap" style="padding-block: 7em">
          <img
            src="../assets/hilow.svg"
            style="width: min(500px, 80vw)"
            alt="1111"
          />
          <h1>YOU LOST</h1>
          YOUR SCORE WAS {{ score }}
        </div>

        <div id="button-wrap" style="padding-block: 4em">
          <button id="play" @click="this.$emit('play')">

            <div id="play-contents" style="display:flex; flex-direction:row; align-items:center; justify-content:center; padding:0.5em;  ">
                
                <img
              src="../assets/status/play.png"
              style="width: 1.5em; filter: invert(100%);  "
              alt=""
            />

            
            Play Again

            </div>
            
          </button>

          <button id="share" @click ="doCopy()">
            Share
            <img
              style="
                margin-left: 5px;
                height: 10px;
                transform: scale(140%);
                filter: invert(1);
              "
              src="../assets/status/share.png"
              alt=""
            />
          </button>

          <p id="copy" :style="this.linkCopied ? '' : 'opacity:0%; '">Link Copied To Clipboard</p>
        </div>
      </div>
    </Transition>
  </div>
</template>


<script>
export default {
  props: {
    enabled: Boolean,
    score: Number,
  },

 data(){
    return{
        linkCopied:false
    }
 }, 

  methods:{
    doCopy(){
        console.log(navigator.clipboard); 
        navigator.clipboard.writeText(window.location);
        this.linkCopied= true; 

        setTimeout( ()=> this.linkCopied=false , 5000)
    }

}
};


</script>

<style scoped>
#bg {
  background-color: rgba(255, 255, 255, 0);
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100vw;
  height: 100vh;

  overflow: hidden;

  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

#color {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.927);

  pointer-events: all;
  overflow: visible;

  z-index: 200;
}

button {
  background-color: #2b3d4f; 
  color: white;
  border: 2px solid #2b3d4f;
  border-radius: 20em;
  border-bottom-color: #2b3d4f;
  padding-inline: 2em;
  padding-block: 0.7em;
  margin-inline: 1em;
  transition: all 0.5s ease;
  backdrop-filter: blur(10px);
  font-weight: 800;
  font-size: 0.7em;

  
}


#copy{
    opacity: 100%;
    color:rgb(189, 189, 189); font-family:monospace; 
    transform: all 0.8s linear;
}
button:hover {
  transform: scale(105%);
}

#button-wrap {
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
  gap: 1em;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.55s ease-out;
}

.slide-up-enter-from {
  opacity: 0;

  scale: 20%;

  border-radius: 500px;
}

.slide-up-leave-to {
  opacity: 0;

  scale: 0%;

  border-radius: 500px;
}
</style>